var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fal fa-cogs"}),_vm._v(" "),_c('span',[_vm._v("\n            "+_vm._s(_vm.$t('notifications'))+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }